import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { } from 'react-router-dom';
import { compose } from 'redux';
import { ChannelManagement, LayoutWrapperMain, Page } from '../../components';
import config from '../../config';
import './channelmanagement.global.scss';

interface Props {
  scrollingDisabled: boolean,
  // from injectIntl
  intl: any,
}

const ChannelManagementComponent: React.FC<Props> = (props: Props) => {
  const {
    intl,
    scrollingDisabled,
  } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'Channelmanagement.Page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <ChannelManagement />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const ChannelManagementComponentPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(ChannelManagementComponent);

export default ChannelManagementComponentPage;
